import { render } from 'storyblok-rich-text-react-renderer';

import { blokHasManyNodes } from '@monoimin/molecules/richtext/utils/blokHasManyNodes';

import { RichTextPreviewMessage } from '@monoimin/molecules/richtext/components/RichtextPreviewMessage';

import { validContentRichText } from '@monoimin/utils/helpers';

import { getAllResolvers } from './utils/getAllResolvers';

import { RichTextOverlay } from './components/RichTextOverlay';

import { SbRichTextProps } from './types';

export const SbRichTextLite = (props: SbRichTextProps) => {
  const { blok, theme, className, itemProp, dataTestId } = props;
  const isValidRichText = validContentRichText(blok);

  const hasManyNodes = blokHasManyNodes(blok);
  if (!isValidRichText && hasManyNodes) {
    return <RichTextPreviewMessage />;
  }
  if (!isValidRichText) {
    return null;
  }
  return (
    <RichTextOverlay
      className={className}
      itemProp={itemProp}
      theme={theme}
      isLight
      dataTestId={dataTestId}
    >
      {render(blok, getAllResolvers(props))}
    </RichTextOverlay>
  );
};
